import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { PlayerEnums } from '../../../shared/GameEnums.ts';
import { clientI18n } from './ClientI18n.ts';
import { setElementOnClick } from './ui_utils/DomUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { SocketLobbySend } from './socket/SocketLobbySend.ts';
import { RoomType } from '@colonist/lobby-types';
import { SDKRequest } from '../../../shared/DiscordActivityTypes.ts';
import { DiscordInviteShareHelper } from './discord/DiscordInviteShareHelper.ts';
// eslint-disable-next-line boundaries/dependencies
import { DiscordInstance } from '../../../client/web/scripts/discord/DiscordInstance.ts';
export class UIDiscordCtaUtils {
    static updateDiscordCTAContent(button, roomData) {
        if (!UIUtilsEjsVariables.isUserOnDiscord) throw new Error('This should only be called on the discord integration server');
        const triggerInviteFriendsPopup = roomData.type == PlayerEnums.ChannelStatus.Closed;
        setElementOnClick(button, ()=>this.defaultMultiplayerCTAAction(triggerInviteFriendsPopup));
        if (roomData.type == PlayerEnums.ChannelStatus.Closed) {
            button.innerText = clientI18n.t('strings:homePage.ctas.play.title', {
                context: 'discord'
            });
            return;
        }
        if (roomData.type == PlayerEnums.ChannelStatus.Game) {
            button.innerText = clientI18n.t('strings:homePage.ctas.spectate');
            return;
        }
        if (roomData.type == PlayerEnums.ChannelStatus.Reconnect) {
            button.innerText = clientI18n.t('strings:homePage.ctas.rejoinGame');
            return;
        }
        const playersInRoom = roomData.playersInRoom;
        const maxPlayers = roomData.maxPlayers;
        const isGameFull = playersInRoom >= maxPlayers;
        if (isGameFull) {
            button.innerText = clientI18n.t('strings:homePage.ctas.roomFull');
            return;
        }
        button.innerText = clientI18n.t('strings:homePage.ctas.joinRoom');
    }
    static shouldTriggerInviteFriendsPopup(triggerInviteFriendsPopup, discordInstance) {
        if (!triggerInviteFriendsPopup) return false;
        return DiscordInviteShareHelper.canOpenInviteFriendsDialog({
            inDiscordServer: discordInstance.inDiscordServer,
            canInviteFriends: discordInstance.canInviteFriends
        });
    }
    static defaultMultiplayerCTAAction(triggerInviteFriendsPopup) {
        AudioManager.play(AudioType.Click);
        const channelId = DiscordInstance.getDiscordInstance().voiceChannelId;
        SocketLobbySend.clickedJoinChannelRoomOrGame(channelId, RoomType.DiscordActivity);
        if (this.shouldTriggerInviteFriendsPopup(triggerInviteFriendsPopup, DiscordInstance.getDiscordInstance())) DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.InviteFriends);
    }
}
